import axios from 'axios'
import {AuthModel, UserModel} from './_models'
import request from 'graphql-request'
import BASEURL from '../../Utils/Baseurl'
import { CHANGE_PASSWORD, FORGOT_PASSWORD, LOGIN } from './_query.ts'

const API_URL = 'http://127.0.0.1:8000/graphql/'

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
export function login(email: string, password: string) {
  return  request(BASEURL, LOGIN, {
    email:email,
    password:password,
  })
}

//reset-pass
export function resetPassword(token: string, newPassword1: string,newPassword2: string) {
  return  request(BASEURL, CHANGE_PASSWORD, {
    token:token,
    newPassword1:newPassword1,
    newPassword2:newPassword1
  })
}

//reset req
export function forgotPassword(email: string) {
  return  request(BASEURL,FORGOT_PASSWORD, {
    email:email,
  })
}
// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    token: token,
  })
}
